import * as React from 'react';

const Profile2 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 16C8.342 16 6.155 17.01 5.352 19H18.648C17.845 17.01 15.658 16 12 16ZM12 14C17.515 14 21 16.275 21 21H3C3 16.275 6.485 14 12 14ZM12 4C14.2 4 16 5.8 16 8C16 10.2 14.2 12 12 12C9.8 12 8 10.2 8 8C8 5.8 9.8 4 12 4ZM12 6C10.905 6 10 6.905 10 8C10 9.095 10.905 10 12 10C13.095 10 14 9.095 14 8C14 6.905 13.095 6 12 6Z" fill="currentColor"/>
  </svg>
);

export default Profile2;
